(function () {
  function initControllerStage(stage) {
    var toggle = stage.querySelector('.nir-toggle-card');
    var status = stage.querySelector('.nir-toggle-text em');

    if (!toggle || !status) return;
    if (toggle.dataset.alNirReady === 'true') return;
    toggle.dataset.alNirReady = 'true';

    var onText = toggle.getAttribute('data-on-text') || 'ON';
    var offText = toggle.getAttribute('data-off-text') || 'OFF';

    toggle.addEventListener('click', function () {
      var isOn = stage.getAttribute('data-nir-state') !== 'off';
      var nextState = isOn ? 'off' : 'on';

      stage.setAttribute('data-nir-state', nextState);
      toggle.setAttribute('aria-pressed', nextState === 'on' ? 'true' : 'false');
      status.textContent = nextState === 'on' ? onText : offText;
    });
  }

  function init(root) {
    root.querySelectorAll('.controller-stage').forEach(initControllerStage);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.al-nir-control').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      initAll(event.target);
    }
  });
})();
